import { all, call, put, takeEvery } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import { GlobalActions, GlobalAction } from '../global-actions';
import { getEndpointUrl, HTTP_METHOD } from '../payload-models';

export interface UpdateDocumentsPayload {
  documentIds: string[];
  cryptId: string;
  appId?: App;
  isSdwSession?: boolean;
}

export interface UpdateDocumentAdditionalData {
  documentId: string;
  cryptId: string;
}

export enum UPDATE_DOCUMENTS_EVENTS {
  UPDATE_DOCUMENTS_SUCCESSFUL = 'UPDATE_DOCUMENTS_SUCCESSFUL',
  UPDATE_DOCUMENTS_FAILED = 'UPDATE_DOCUMENTS_FAILED',
}

export function* watchUpdateDocumentsWithCryptId() {
  yield takeEvery(
    GlobalActions.UPDATE_DOCUMENTS_WITH_CRYPTID,
    updateDocumentsWithCryptIdWorker,
  );
}

export function* updateDocumentsWithCryptIdWorker(action: GlobalAction<UpdateDocumentsPayload>) {
  const { documentIds, cryptId, appId = App.SHOP_DASHBOARD, isSdwSession = false } = action.payload;

  if (!documentIds || documentIds.length === 0) {
    return;
  }

  if (!cryptId) {
    return;
  }

  const updateRequests = documentIds.map(documentId =>
    call(updateSingleDocument, documentId, cryptId, appId, isSdwSession)
  );

  yield all(updateRequests);
}

function* updateSingleDocument(documentId: string, cryptId: string, appId: App, isSdwSession: boolean) {
  yield put(
    new GlobalActions().doRequest({
      appId: appId,
      method: HTTP_METHOD.POST,
      url: getEndpointUrl(isSdwSession, `/privatschutz/api/sds/${documentId}/update`),
      body: {
        masterId: cryptId,
      },
      successEvent: UPDATE_DOCUMENTS_EVENTS.UPDATE_DOCUMENTS_SUCCESSFUL,
      errorEvent: UPDATE_DOCUMENTS_EVENTS.UPDATE_DOCUMENTS_FAILED,
      additionalData: {
        documentId,
        cryptId,
      } as UpdateDocumentAdditionalData,
    }),
  );
}
